import { Component, OnChanges, Input, ViewChild } from '@angular/core';
import { CCRPSMToken, CCRPStatusMonitoring, CCRPDayToken, DailyTokenItem, DailyToken } from '../../shared/misc-classes';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';

@Component({
  selector: 'app-ccrp',
  templateUrl: './ccrp.component.html',
  styleUrls: ['./ccrp.component.css']
})
export class CcrpComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() datatables:CCRPStatusMonitoring;  
  ccrpDayTokenObj:CCRPDayToken;
  allData:CCRPStatusMonitoring;

  constructor(private _dataService:DataService) { }

  ngOnChanges() {
    this.loadAllData();
    if(this.currMonthDtObj){
      this.loadDateData();
    }
  }
  
  loadAllData(){
    this._dataService.loadCCRPAllData().subscribe((_cstInspPlan:any) => {
      if(_cstInspPlan!=null){
      this.allData = _cstInspPlan;
      }
    });
  }
  loadDateData():void{
    if(this.datatables){
      let _tmpDPHDayToken:CCRPDayToken = this.datatables.getDateToken(this.currMonthDtObj);
      if(_tmpDPHDayToken == null){
        this.datatables.addDateToken(this.currMonthDtObj,null,null,null,null,null,null);  
        _tmpDPHDayToken = this.datatables.getDateToken(this.currMonthDtObj);
      }
      this.ccrpDayTokenObj = _tmpDPHDayToken;
    }
    else{
      this.ccrpDayTokenObj = new CCRPDayToken(this.currMonthDtObj,'','','','','','',[])
    }
 
  }
  getData(option){
    if(option) return option
    return ''
  }
  getResponsiblePrsn(_prsn:string):string{
    if(_prsn) return this._dataService.getResponsiblePrsn(_prsn); 
    return ''
  }
  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }

}
